export default __webpack_public_path__ + "static/media/Nainital city.06ad6537.jpg";